import React, { useState, useEffect, useCallback, useRef } from 'react';
import ProductOptions from '../components/LegacyMiniCart/productOptions';
import defaultClasses from './savedConfigurators.module.css';
import { useStyle } from '../lib/util/classify';
import classNames from '../lib/util/classNames';
import { Price } from '../peregrine';
import {
    Trash2 as TrashIcon,
    ArrowRight as MoveIcon,
    Upload as UploadIcon,
    PlusCircle as AddIcon
} from 'react-feather';
import dateToLocaleFormat from '../lib/util/dateToLocaleFormat';
import { configuratorOptionsToProductOptions } from './configuratorSection';

const SavedConfiguratorItem = props => {
    const {
        item,
        removeFromWishlist,
        isRemovingFromWishlist,
        group: currentGroup,
        groups,
        onGroupChange
    } = props;
    const classes = useStyle(defaultClasses, props.classes);

    const [isGroupListOpen, setIsGroupListOpen] = useState(false);
    const groupListRef = useRef();
    const {
        wishlistId,
        wishlistItemId,
        id,
        url,
        title,
        date,
        customOptionValue: configured,
        customPrice
    } = item;

    const moveToNewGroup = useCallback(() => {
        const newGroupName = _(
            'Project created on {0}',
            dateToLocaleFormat(new Date())
        );
        onGroupChange(wishlistId, wishlistItemId, id, newGroupName);
    }, [onGroupChange, wishlistId, wishlistItemId, id]);

    const moveToGroup = useCallback(
        newGroup => {
            if (newGroup != currentGroup) {
                onGroupChange(wishlistId, wishlistItemId, id, newGroup);
            }
        },
        [currentGroup, onGroupChange]
    );

    const toggleGroupList = () => setIsGroupListOpen(!isGroupListOpen);

    useEffect(() => {
        const handleClickOutside = e => {
            if (
                groupListRef.current &&
                !groupListRef.current.contains(e.target)
            ) {
                setIsGroupListOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={classes.item}>
            <div className={classes.title}>
                <a href={url}>{title}</a>
                <span className={classes.savedDate}>
                    {_('Saved on {0}', dateToLocaleFormat(date))}
                </span>
            </div>

            <ProductOptions
                options={configuratorOptionsToProductOptions(configured)}
            />

            {/* <Price value={customPrice} currencyCode='EUR' /> */}

            <div className={classes.actions}>
                <a
                    href={url}
                    className={classNames(classes.button, classes.load)}
                >
                    <UploadIcon className={classes.icon} />
                    {_('Load this configurator')}
                </a>

                <div
                    className={classNames(classes.moveWrapper)}
                    ref={groupListRef}
                >
                    <button
                        className={classNames(classes.button, classes.move)}
                        disabled={isRemovingFromWishlist}
                        onClick={toggleGroupList}
                        aria-expanded={isGroupListOpen}
                        aria-haspopup={true}
                    >
                        <MoveIcon className={classes.icon} />
                        {_('Move to other project')}
                    </button>
                    {isGroupListOpen && (
                        <ul className={classes.groupsList}>
                            <li
                                className={classNames(
                                    classes.groupItem,
                                    classes.newGroup
                                )}
                                onClick={moveToNewGroup}
                            >
                                <AddIcon width={16} />
                                {_('Create new project')}
                            </li>
                            {groups
                                .filter(group => group != currentGroup)
                                .map(group => (
                                    <li
                                        key={group}
                                        className={classes.groupItem}
                                        onClick={() => moveToGroup(group)}
                                    >
                                        {group}
                                    </li>
                                ))}
                        </ul>
                    )}
                </div>

                <button
                    className={classNames(classes.button, classes.delete)}
                    disabled={isRemovingFromWishlist}
                    onClick={() =>
                        removeFromWishlist(wishlistId, wishlistItemId, id)
                    }
                >
                    <TrashIcon className={classes.icon} />
                    {_('Remove')}
                </button>
            </div>
        </div>
    );
};

export default SavedConfiguratorItem;
